// Module
var code = `<div class="popup-error-screen{{#withBorder}} error-border{{/}} {{.elementStyle}} {{additionalStyle}}" style="position: absolute; left: {{.left || 0}}px; top: {{.top || 0}}px; width: {{.width|| 0}}px;{{^.visible}}visibility: hidden; {{/}}">
    {{#headerVisible}}<div class="js-tercera-label-error">{{.headerText}}</div>{{/}}
    <div class="js-tercera-label">{{.errorText}}</div>
</div>
`;
// Exports
export default code;